import React from 'react';
import classnames from 'classnames';
import './CampaignStatusIcon.scss';
import campaignActiveIcon from 'assets/campaign-active.svg';
import campaignEndedIcon from 'assets/campaign-ended.svg';
import campaignDraftIcon from 'assets/campaign-draft.svg';
import { CampaignTypeWithMappedPurposeAndDisplayStatus } from '@mm/state/selectors/campaignSelectors';

type Props = {
  campaign: CampaignTypeWithMappedPurposeAndDisplayStatus;
  className?: string;
  showOnlyStatus?: boolean;
};

const campaignDisplayIcon = (
  campaign: CampaignTypeWithMappedPurposeAndDisplayStatus,
) => {
  switch (campaign.displayStatus) {
    case 'Delivered':
      return <i className="campaign-status-icon__icon far fa-envelope-open" />;
    case 'Queued':
    case 'Sending':
    case 'Canceled':
      return <i className="campaign-status-icon__icon far fa-envelope" />;
    case 'Active':
      return (
        <img className="campaign-status-icon__icon" src={campaignActiveIcon} />
      );
    case 'Paused':
    case 'Draft':
      return (
        <img className="campaign-status-icon__icon" src={campaignDraftIcon} />
      );
    case 'Ended':
      return (
        <img className="campaign-status-icon__icon" src={campaignEndedIcon} />
      );
    default:
  }
};

const CampaignStatusIcon = ({ campaign, className, showOnlyStatus }: Props) => {
  const classList = classnames(
    'campaign-status-icon',
    `campaign-status-icon__${campaign.displayStatus.toLowerCase()}`,
    className,
  );

  return (
    <div className={classList}>
      {!showOnlyStatus && campaignDisplayIcon(campaign)}
      {campaign.displayStatus}
    </div>
  );
};

export default CampaignStatusIcon;
